import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";
import { apiError } from "@/lib/platform";
import { Panel } from "@/components/rights/RightsBadges";
import { Field, Pick } from "@/components/vendors/NewVendorDialog";

const KEYS = ["name", "legal_name", "service_type", "owner", "country", "website", "status", "description"];

export const VendorDetails = ({ v, meta, users, canEdit, onChanged }) => {
  const [f, setF] = useState(Object.fromEntries(KEYS.map((k) => [k, v[k] || ""])));
  const [comment, setComment] = useState("");
  const set = (k) => (x) => setF((s) => ({ ...s, [k]: x?.target ? x.target.value : x }));
  const dirty = KEYS.filter((k) => f[k] !== (v[k] || ""));
  const offboarding = f.status === "OFFBOARDED" && v.status !== "OFFBOARDED";
  const save = async () => {
    try {
      await api.patch(`/vendors/${v.id}`, { ...Object.fromEntries(dirty.map((k) => [k, f[k]])), comment });
      toast.success("Vendor profile saved");
      setComment("");
      onChanged();
    } catch (e) { toast.error(apiError(e, "Could not save")); }
  };
  return (
    <Panel eyebrow={`Work item ${v.vendor_id}`} title="Vendor profile" testId="vendor-details">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Field label="Name"><Input value={f.name} onChange={set("name")} disabled={!canEdit} className="h-9 text-sm" data-testid="vendor-detail-name" /></Field>
        <Field label="Legal entity"><Input value={f.legal_name} onChange={set("legal_name")} disabled={!canEdit} className="h-9 text-sm" data-testid="vendor-detail-legal" /></Field>
        <Field label="Service type"><Pick value={f.service_type} onChange={set("service_type")} disabled={!canEdit} options={meta.service_types.map((s) => [s, s])} testId="vendor-detail-service" /></Field>
        <Field label="Owner"><Pick value={f.owner} onChange={set("owner")} disabled={!canEdit} options={users.map((u) => [u.username, u.full_name || u.username])} testId="vendor-detail-owner" /></Field>
        <Field label="Country"><Input value={f.country} onChange={set("country")} disabled={!canEdit} className="h-9 text-sm" data-testid="vendor-detail-country" /></Field>
        <Field label="Status"><Pick value={f.status} onChange={set("status")} disabled={!canEdit} options={Object.entries(meta.statuses)} testId="vendor-detail-status" /></Field>
        <Field label="Website" className="sm:col-span-2"><Input value={f.website} onChange={set("website")} disabled={!canEdit} className="h-9 text-sm" data-testid="vendor-detail-website" /></Field>
        <Field label="Description" className="sm:col-span-2"><Textarea rows={2} value={f.description} onChange={set("description")} disabled={!canEdit} data-testid="vendor-detail-description" /></Field>
        {offboarding && <Field label="Offboarding comment (required)" className="sm:col-span-2">
          <Textarea rows={2} value={comment} onChange={(e) => setComment(e.target.value)} data-testid="vendor-detail-comment" /></Field>}
      </div>
      {canEdit && dirty.length > 0 && (
        <div className="flex justify-end mt-3">
          <Button size="sm" onClick={save} disabled={offboarding && !comment.trim()} data-testid="vendor-detail-save">Save {dirty.length} change{dirty.length > 1 ? "s" : ""}</Button>
        </div>
      )}
    </Panel>
  );
};
